<template>
  <div class="col">
    <i class="bi bi-plus-lg text-success" @click="setAction('newauction')"></i>
  </div>
  <div class="col">
    <i class="bi bi-pen text-primary" @click="setAction('editauction')"></i>
  </div>
  <div class="col">
    <i class="bi bi-play" @click="setAction('hostauction')"></i>
  </div>
</template>
<script setup>
import { onMounted } from "vue";
import { useStore } from "@/store/index";
const store = useStore();
const setAction = (str) => store.setAction(str);
onMounted(() => {
  setAction("hostauction");
});
</script>
